// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1IIjI","productName":"Table_productName__1AyhD"};